<template>
	<!-- Header(leftside) -->
	<header :class="{active: scrollY > 100}" class="iv2-global theme-b__global-bg">
		<div class="iv2-global__items">
			<h1 v-if="general.logos" class="iv2-global__logo theme-b__global-logo-bg">
				<router-link @click="activeMenu = false" to="/" class="iv2-global__link">
					<img
						:src="general.logos.basic_type1"
						class="iv2-global__logo-img"
						:alt="general.profile.name + alt_text"
					/>
				</router-link>
			</h1>
			<div class="iv2-global__menu d-xl-none d-flex text-center m-auto">
				<!-- Header Sub Menu -->
				<nav class="iv2-global__sub-menu d-none d-md-flex d-xl-none h-100 align-middle">
					<div
						v-for="subnav in extra_menu"
						:key="subnav.id"
						class="iv2-global__sub-menu-item theme-b__global-sns-link text-center d-inline-block align-top"
					>
						<div v-if="subnav.link_type == 'internal'">
							<router-link :to="subnav.url" class="iv2-global__sub-menu-link text-black">
								<i
									:class="
                                        'iv2-global__sub-menu-item-icon d-block ' +
                                            subnav.icon
                                    "
								></i>
								<span class="iv2-global__sub-menu-item-text d-block">{{ subnav.name }}</span>
							</router-link>
						</div>
						<div v-else-if="subnav.link_type == 'external'">
							<a
								v-bind:href="subnav.url"
								:target="subnav.target_type"
								rel="noopener"
								class="iv2-global__sub-menu-link text-black"
							>
								<i
									:class="
                                        'iv2-global__sub-menu-item-icon d-block ' +
                                            subnav.icon
                                    "
								></i>
								<span class="iv2-global__sub-menu-item-text d-block">{{ subnav.name }}</span>
							</a>
						</div>
						<div v-else-if="subnav.link_type == 'push'" class="iv2-global-push-button">
							<button
								class="iv2-global__sub-menu-link text-black align-top"
								style="background-color: transparent; border: none; padding: 0;"
							>
								<i
									id="iv2-global__sub-menu-item-icon"
									:class="
                                        'iv2-global__sub-menu-item-icon d-block ' +
                                            subnav.icon
                                    "
								></i>
								<span class="iv2-global__sub-menu-item-text d-block">{{ subnav.name }}</span>
							</button>
						</div>
					</div>
				</nav>

				<div
					@click="touchHandler"
					class="iv2-global__btn theme-b__global-btn d-inline-block align-middle"
				>
					<div
						:class="{ active: activeMenu }"
						class="iv2-global__btn-icon position-relative bg-transparent border border-0 p-0"
					>
						<span class="iv2-global__top-drawer theme-b__global-icon"></span>
						<span class="iv2-global__center-drawer theme-b__global-icon"></span>
						<span class="iv2-global__bottom-drawer theme-b__global-icon"></span>
					</div>
					<span class="iv2-global__menu-text theme-b__global-text d-block">{{ menu_text }}</span>
				</div>
			</div>
		</div>

		<nav :class="[{ active: activeMenu }, navColorClass]" class="iv2-nav theme-b__nav-text">
			<!-- Navigation Sub Menu -->
			<div class="iv2-nav__block">
				<div v-if="general.profile" class="iv2-nav__header d-none d-xl-flex">
					<div class="iv2-nav__header-tel theme-b__nav-tel d-flex mr-3">
						<span
							v-if="general.profile.tel != ''"
							class="mt-auto mr-2"
							style="margin-bottom: 10px;"
						>{{ tel_text }}</span>
						<p class="iv2-nav__header-tel--text size-32 m-0">{{ general.profile.tel }}</p>
					</div>
					<div class="iv2-nav__header-time mr-3">
						<p v-html="general.profile.business_hours" class="size-12 m-0" style="line-height: 1.5;"></p>
					</div>
					<div class="iv2-nav__header-address mr-3">
						<p v-html="general.profile.free_text" class="size-12 m-0" style="line-height: 1.5;"></p>
						<p class="size-12 m-0" style="line-height: 1.5;">
							{{ "〒" + general.profile.zipcode }}&emsp;
							{{
							general.profile.address_pref +
							general.profile.address_city +
							general.profile.address_town +
							general.profile.address_build
							}}
						</p>
					</div>
				</div>
				<ul v-if="sns.facebook" class="iv2-nav__list list-unstyled">
					<li
						v-for="nav in global_menu.slice(0, 16)"
						:key="nav.id"
						class="iv2-nav__item theme-b__nav-item"
						:class="{
                            selected:
                                activeNav === nav
                        }"
						@mouseover="activeNav = nav"
						@mouseleave="activeNav = ''"
					>
						<router-link
							v-if="
                                nav.link_type == 'internal' &&
                                    !nav.children.length == true
                            "
							:to="nav.url"
							class="iv2-nav__link theme-b__nav-link"
						>{{ nav.name }}</router-link>
						<a
							v-else-if="
                                nav.link_type == 'external' &&
                                    !nav.children.length == true
                            "
							:href="nav.url"
							:target="nav.target_type"
							rel="noopener"
							class="iv2-nav__link theme-b__nav-link"
						>{{ nav.name }}</a>
						<router-link
							v-if="
                                nav.link_type == 'internal' &&
                                    !nav.children.length == false
                            "
							:to="nav.url"
							class="iv2-nav__link iv2-nav__link-parent theme-b__nav-link"
						>{{ nav.name }}</router-link>
						<a
							v-else-if="
                                nav.link_type == 'external' &&
                                    !nav.children.length == false
                            "
							:href="nav.url"
							:target="nav.target_type"
							rel="noopener"
							class="iv2-nav__link iv2-nav__link-parent theme-b__nav-link"
						>{{ nav.name }}</a>
						<a
							v-if="!nav.children.length == false"
							@click="activeList"
							class="iv2-nav__acordion theme-b__nav-acordion d-inline-block d-xl-none position-relative"
							href="javascript:void(0)"
						></a>
						<ul
							v-if="!nav.children.length == false"
							:class="navChildColor"
							class="iv2-nav__list list-unstyled"
						>
							<li
								v-for="cNav in nav.children"
								:key="cNav.id"
								class="iv2-nav__item theme-b__nav-item--inner"
							>
								<router-link
									v-if="cNav.link_type == 'internal'"
									:to="cNav.url"
									class="iv2-nav__link theme-b__nav-link--inner"
								>{{ cNav.name }}</router-link>
								<a
									v-else-if="cNav.link_type == 'external'"
									:href="cNav.url"
									:target="cNav.target_type"
									rel="noopener"
									class="iv2-nav__link theme-b__nav-link--inner"
								>{{ cNav.name }}</a>
							</li>
						</ul>
					</li>
				</ul>

				<div class="iv2-nav__footer container-fluid">
					<div v-if="general.profile" class="iv2-nav__footer-item">
						<div v-if="general.profile.tel != ''" class="iv2-nav__footer-tel d-inline-flex">
							<p v-if="general.profile.tel != ''" class="size-14 m-0 mr-1">{{ tel_text }}</p>
							<p class="iv2-nav__footer-tel--text size-14 m-0">{{ general.profile.tel }}</p>
						</div>

						<div class="iv2-nav__footer-time">
							<p v-html="general.profile.business_hours" class="size-14 mt-xl-2" style="line-height: 1.3;"></p>
						</div>
						<p v-html="general.profile.free_text" class="size-14" style="line-height: 1.5;"></p>
						<div class="iv2-nav__footer-adress p-0">
							<p class="size-14 m-0" style="line-height: 1.3;">{{ "〒" + general.profile.zipcode }}</p>
							<p class="size-14 m-0" style="line-height: 1.3;">
								{{
								general.profile.address_pref +
								general.profile.address_city +
								general.profile.address_town +
								general.profile.address_build
								}}
							</p>
						</div>
					</div>
					<div class="d-block d-xl-none text-center mt-4">
						<!-- SP SNS -->
						<div class="iv2-nav__mobile-sns m-auto">
							<ul
								v-if="
                                        sns.facebook &&
                                            sns.instagram &&
                                            sns.twitter &&
                                            sns.line &&
                                            rss.outbound
                                    "
								class="iv2-nav__mobile-sns-list mb-0 list-unstyled"
							>
								<li v-if="sns.facebook.status == 1" class="iv2-nav__mobile-sns-item">
									<a
										:href="sns.facebook.url"
										class="iv2-nav__mobile-sns-link theme-b__nav-sns-link"
										target="_blank"
										rel="noopener"
									>
										<i class="fab fa-facebook-f"></i>
									</a>
								</li>
								<li v-if="sns.instagram.status == 1" class="iv2-nav__mobile-sns-item">
									<a
										:href="sns.instagram.url"
										class="iv2-nav__mobile-sns-link theme-b__nav-sns-link"
										target="_blank"
										rel="noopener"
									>
										<i class="fab fa-instagram"></i>
									</a>
								</li>
								<li v-if="sns.twitter.status == 1" class="iv2-nav__mobile-sns-item">
									<a
										:href="sns.twitter.url"
										class="iv2-nav__mobile-sns-link theme-b__nav-sns-link"
										target="_blank"
										rel="noopener"
									>
										<i class="fab fa-twitter"></i>
									</a>
								</li>
								<li v-if="sns.line.status == 1" class="iv2-nav__mobile-sns-item">
									<a
										:href="sns.line.url"
										class="iv2-nav__mobile-sns-link theme-b__nav-sns-link"
										target="_blank"
										rel="noopener"
									>
										<i class="fab fa-line"></i>
									</a>
								</li>
								<li v-if="rss.outbound.status == 1" class="iv2-nav__mobile-sns-item">
									<a
										:href="rss.outbound.href"
										class="iv2-nav__mobile-sns-link theme-b__nav-sns-link"
										target="_blank"
										rel="noopener"
									>
										<i class="fas fa-rss"></i>
									</a>
								</li>
							</ul>
						</div>
						<div class="iv2-nav__copyright">
							<small>{{ general.copyright }}</small>
						</div>
					</div>
				</div>
			</div>
		</nav>
	</header>
</template>

<script>
export default {
	data() {
		return {
			general: [],
			global_menu: [],
			extra_menu: [],
			sns: [],
			rss: [],

			alt_text: "のロゴ",
			tel_text: "TEL.",
			menu_text: "",

			activeMenu: true,
			activeNav: "",
			navColorClass: "",
			navChildColor: "",
			scrollY: 0,
		};
	},

	created() {
		this.axios.get("/json/settings.json").then((response) => {
			this.general = response.data.settings.general;
			this.sns = response.data.settings.sns;
		});

		this.axios.get("/json/navigations.json").then((response) => {
			this.global_menu = response.data.navs.global_menu;
			this.extra_menu = response.data.navs.extra_menu;
		});

		this.axios.get("/json/rss.json").then((response) => {
			this.rss = response.data.rss;
		});

		window.addEventListener("scroll", this.handleScroll);

		window.addEventListener("resize", this.handleResize);
		this.handleResize();

		this.menu_text = "MENU";
	},

	mounted() {
		this.handleResize();
		{
			if (window.innerWidth <= 1199) {
				this.activeMenu = false;
			} else {
				this.activeMenu = true;
			}
		}
	},

	destroyed() {
		window.removeEventListener("resize", this.handleResize);
	},

	methods: {
		activeList: function (e) {
			e.currentTarget.parentNode.classList.toggle("active");
		},

		handleScroll: function () {
			this.scrollY = window.scrollY;
		},

		handleResize: function () {
			// if (window.innerWidth >= 1200) {
			// 	this.activeMenu = true;
			// }

			if (window.innerWidth >= 1199) {
				this.navColorClass = "theme-b__global-bg";
			} else {
				this.navColorClass = "theme-b__nav-bg";
			}

			if (window.innerWidth >= 1199) {
				this.navChildColor = "theme-b__nav-bg";
			} else {
				this.navChildColor = "";
			}
		},

		touchHandler() {
			this.activeMenu = !this.activeMenu;

			if (this.activeMenu == true) {
				document.body.classList = "noscroll";
			} else {
				document.body.classList = "";
			}

			if (this.activeMenu == true) {
				this.menu_text = "CLOSE";
			} else {
				this.menu_text = "MENU";
			}
		},
	},

	watch: {
		$route: function (to, from) {
			document.body.classList = "";
			if (to.path !== from.path && window.innerWidth <= 1199) {
				this.activeMenu = false;
				this.menu_text = "MENU";
			}
		},
	},
};
</script>

<style lang="scss">
.iv2-global {
	.iv2-global__items {
		.iv2-global__logo {
			margin: auto;
			padding: 5px 10px;
			position: relative;
			z-index: 11;
			-webkit-box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.1);
			box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.1);

			.iv2-global__logo-img {
				max-width: 80%;
				max-height: 70%;
				position: absolute;
				top: 50%;
				left: 50%;
				transform: translateX(-50%) translateY(-50%);
			}
		}

		.iv2-global__menu {
			top: 50%;
			left: 0;
			right: 0;

			.iv2-global__btn {
				.iv2-global__btn-icon {
					width: 30px;
					height: 25px;
					margin: 0 auto;
					cursor: pointer;

					.iv2-global__top-drawer,
					.iv2-global__center-drawer,
					.iv2-global__bottom-drawer {
						display: block;
						position: absolute;
						width: 100%;
						height: 2px;
						margin: auto;
						right: 0;
						left: 0;
						transition: 0.3s;
					}

					.iv2-global__top-drawer {
						top: 2px;
					}

					.iv2-global__center-drawer {
						top: 0;
						bottom: 0;
						visibility: visible;
						opacity: 1;
					}

					.iv2-global__bottom-drawer {
						bottom: 2px;
					}

					&.active {
						.iv2-global__top-drawer {
							top: 0;
							bottom: 0;
							transform: rotate(-45deg);
						}

						.iv2-global__center-drawer {
							visibility: hidden;
							opacity: 0;
						}

						.iv2-global__bottom-drawer {
							top: 0;
							bottom: 0;
							transform: rotate(45deg);
						}
					}

					&:focus {
						outline: 0;
					}
				}
			}

			.iv2-global__menu-text {
				font-size: 10px;
				font-weight: 400;
				line-height: 1;
			}
		}
	}

	.iv2-nav {
		width: 100%;
		z-index: 5;
		visibility: hidden;
		display: none;

		&.active {
			visibility: visible;
			display: block;
		}

		.iv2-nav__block {
			> .iv2-nav__list {
				display: inline-block;
				vertical-align: top;

				.iv2-nav__item {
					font-size: 16px;
					letter-spacing: 2px;

					.iv2-nav__link {
						&:hover {
							text-decoration: none;
						}
					}

					> .iv2-nav__list {
						padding-left: 20px;
						padding-left: 0;

						.iv2-nav__item {
							font-size: 16px;
						}
					}
				}
			}
		}

		.iv2-nav__footer {
			padding: 1.5rem 1.5rem 0;
			margin-left: 0;
			margin-right: 0;
			z-index: 1;
		}
	}
}

/* PC */
@media (min-width: 1200px) {
	@keyframes tooltipShow {
		from {
			opacity: 0;
			transform: translateX(-20px);
		}

		to {
			opacity: 1;
		}
	}

	@keyframes fade-move {
		0% {
			transform-origin: 0% 0;
			transform: translate3d(0%, 0%, 0px) scale(1, 0);
		}

		100% {
			transform-origin: 0% 0;
			transform: translate3d(0%, 0%, 0px) scale(1, 1);
		}
	}

	.iv2-global {
		display: flex;
		transition: 0.3s;

		&.active {
			height: 70px;

			.iv2-global__items {
				height: 144px;
			}

			.iv2-nav {
				.iv2-nav__block {
					.iv2-nav__header {
						height: 0;
						opacity: 0;
					}

					> .iv2-nav__list {
						height: 100%;

						.iv2-nav__item {
							.iv2-nav__link {
								padding: 17px 25px 0;
							}

							.iv2-nav__link-parent {
								padding-right: 30px;
							}
						}
					}
				}
			}
		}

		.iv2-global__items {
			width: 370px;
			height: 207px;
			transition: 0.3s;

			.iv2-global__logo {
				width: 100%;
				height: 100%;
			}
		}

		.iv2-nav {
			height: 100%;

			.iv2-nav__block {
				height: 100%;

				.iv2-nav__header {
					height: 50%;
					align-items: center;
					justify-content: flex-end;
					transition: 0.3s;

					.iv2-nav__header-tel {
						.iv2-nav__header-tel--text {
							font-weight: 600;
						}
					}
				}

				> .iv2-nav__list {
					height: 50%;
					margin: 0;
					display: flex;
					align-items: center;
					justify-content: flex-end;
					transition: 0.3s;

					.iv2-nav__item {
						font-size: 14px;
						line-height: 2.6;
						height: 100%;
						letter-spacing: 0;
						position: relative;

						.iv2-nav__link {
							padding: 10px 25px 0;
							display: block;
							position: relative;
							height: 100%;
							transition: 0.3s;
						}

						.iv2-nav__link-parent {
							padding-right: 30px;

							&::before {
								content: "";
								width: 5px;
								height: 5px;
								border-left: 2px solid;
								border-bottom: 2px solid;
								margin: 0;
								display: block;
								position: absolute;
								right: 13px;
								top: 50%;
								transform: translateY(-50%) rotate(-45deg);
							}
						}

						&:last-child {
							> .iv2-nav__list {
								right: 0;
							}
						}

						> .iv2-nav__list {
							height: auto;
							width: 230px;
							text-align: center;
							position: absolute;
							top: 100%;
							visibility: hidden;
							transition: 0.5s;
							z-index: 0;
							opacity: 0;
							-webkit-box-shadow: 0px 3px 5px rgba(0, 0, 0, 0.1);
							box-shadow: 0px 3px 5px rgba(0, 0, 0, 0.1);

							.iv2-nav__item {
								font-size: 16px;
								height: auto;

								&:last-child {
									border-bottom: 0;
								}

								.iv2-nav__link {
									padding: 10px 0;
									width: 100%;
									display: block;
								}
							}
						}

						&.selected {
							> .iv2-nav__list {
								visibility: visible;
								opacity: 1;
							}
						}
					}
				}
			}

			.iv2-nav__footer {
				display: none;
			}
		}
	}
}

/* TABLET or SP */
@media (max-width: 1199px) {
	@keyframes tooltipShow {
		from {
			opacity: 0;
			transform: translateY(-30px);
		}

		to {
			opacity: 1;
		}
	}

	.iv2-global {
		.iv2-global__items {
			height: 100%;

			.iv2-global__logo {
				display: inline-block;
				width: 200px;
				height: 112px;

				.iv2-global__link {
					margin-bottom: 0;
					height: 100%;
					display: block;
				}
			}

			.iv2-global__menu {
				height: 100%;
				float: right;

				.iv2-global__btn {
					line-height: 1;
				}

				.iv2-global__menu-text {
					margin-top: 8px;
				}
			}
		}

		.iv2-nav {
			position: absolute;
			top: 0;
			left: 0;
			margin-top: 74px;
			height: 100vh;
			overflow-y: auto;
			overflow-x: hidden;

			.iv2-nav__sub-menu-item {
				font-size: 1.75em;
				border-right: 1px solid;

				&:last-child {
					border-right: none;
				}
			}

			.iv2-nav__sub-menu-item-text {
				font-size: 0.5em;
				line-height: 1.3;
			}

			.iv2-nav__block {
				padding: 50px 20px 20px;
				animation: tooltipShow 0.5s linear 0s;

				.iv2-nav__list {
					display: block;
					margin: auto;
					padding: 0 64px;
					float: none;

					.iv2-nav__item {
						position: relative;
						display: block;
						font-size: 1em;
						margin: 0;

						.iv2-nav__link {
							display: block;
							padding: 15px 0;
						}

						.iv2-nav__link-parent {
							width: 80%;
						}

						> .iv2-nav__list {
							padding: 0;
							visibility: hidden;
							opacity: 0;
							height: 0;

							&.active {
								visibility: visible;
								opacity: 1;
								height: auto;
								transition: 0.5s;
							}
						}

						.iv2-nav__acordion {
							width: 27px;
							height: 45px;
							float: right;
							-webkit-transform: translateY(-100%);
							transform: translateY(-100%);
							bottom: 15px;
							margin-right: 10px;

							&::before {
								content: "";
								width: 20px;
								height: 20px;
								position: absolute;
								top: 50%;
								right: 50%;
								transform: translateX(50%) translateY(-50%)
									rotate(-45deg);
								transition: 0.2s;
							}

							&::after {
								content: "";
								width: 20px;
								height: 20px;
								position: absolute;
								top: 50%;
								right: 50%;
								transform: translateX(50%) translateY(-50%)
									rotate(-45deg);
								transition: 0.2s;
							}
						}

						&.active {
							> .iv2-nav__list {
								visibility: visible;
								opacity: 1;
								height: auto;

								> .iv2-nav__item {
									font-size: 1em;
								}
							}

							.iv2-nav__acordion {
								&::before {
									right: 0;
								}

								&::after {
									right: 100%;
								}
							}
						}
					}
				}
			}

			.iv2-nav__footer {
				padding: 1.5rem 4rem 6rem;
				margin-top: 2rem;

				.iv2-nav__footer-item {
					padding: 30px 60px;
					background-color: #ffffffb8; //銀のりぼんオリジナル
				}
			}

			.iv2-nav__mobile-sns-list {
				.iv2-nav__mobile-sns-item {
					font-size: 1.1em;
					display: inline-block;
					margin-right: 20px;

					&:last-child {
						margin-right: 0;
					}
				}
			}
		}
	}
}

/* TABLET Only */
@media (min-width: 768px) and (max-width: 1199px) {
	.iv2-global {
		.iv2-global__items {
			.iv2-global__menu {
				.iv2-global__btn {
					width: 74px;
					height: 100%;
					padding: 15px 10px;
				}

				.iv2-global__sub-menu {
					padding: 10px 0;
					align-items: center;

					.iv2-global__sub-menu-item {
						font-size: 1.5rem;
						width: 80px;
						padding: 0 10px;
						position: relative;

						.iv2-global__sub-menu-link {
							&:hover {
								text-decoration: none;
							}
						}

						.iv2-global__sub-menu-item-text {
							font-size: 10px;
							font-weight: 400;
							margin-top: 9px;
							line-height: 1.2;
						}
					}
				}
			}
		}
	}
}

/* SP Only */
@media (max-width: 767px) {
	.iv2-global {
		.iv2-global__items {
			.iv2-global__logo {
				width: 116px;
				height: 65px;
			}

			.iv2-global__menu {
				padding: 6px 10px;

				.iv2-global__menu-text {
					margin-top: 0;
				}

				.iv2-global__btn {
					.iv2-global__btn-icon {
						width: 25px;
						height: 20px;
						margin-bottom: 3px;
					}
				}
			}
		}

		.iv2-nav {
			margin-top: 45px;
			padding-bottom: 10rem;
			padding-bottom: calc(10rem + env(safe-area-inset-bottom));

			.iv2-nav__block {
				.iv2-nav__list {
					padding: 0 21px;

					.iv2-nav__item {
						.iv2-nav__link {
							padding: 10px 5px;
						}

						.iv2-nav__acordion {
							height: 35px;
						}
					}
				}
			}

			.iv2-nav__footer {
				padding: 20px;

				.iv2-nav__footer-item {
					padding: 15px 20px;
				}
			}
		}
	}
}
</style>
